import { Component, OnInit,ViewChild, Input } from '@angular/core';
import { NavParams, ModalController,Platform ,IonInfiniteScroll} from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute ,Router} from '@angular/router';
import { WebParameterContext,WebResponesContext } from 'src/model/common';
import { MessageclientService, NativeService } from 'src/service';
import {CodelessReturnslistPage} from '../codeless-returnslist/codeless-returnslist.page';
@Component({
  selector: 'app-button-selection',
  templateUrl: './button-selection.page.html',
  styleUrls: ['./button-selection.page.scss'],
})
export class ButtonSelectionPage implements OnInit {

  constructor(
    private platform: Platform,
    public modalController: ModalController,
    public  navParams: NavParams,
    public http:HttpCustomerService,
    public com:CommonService,
    public msg:MessageclientService,
    private activaRouter: ActivatedRoute,
    public native: NativeService,
    private router: Router,
  ) { }

  ngOnInit() {
  }
  // 跳转有码按钮
  comfireModal() {
  const that=this;
  console.log("确认按钮");
  this.modalController.dismiss({
    "type": "1"
  });
   that.com.setHistoryUrl(true);
   that.com.Go("/tabs/contact/ReturnGoods/"+ this.com.getNowDatetime);
  // that.router.navigate(["/tabs/contact/ReturnGoods/" + this.com.getNowDatetime], {
  //   queryParams: {
  //   }
  // });
}
//  跳转无码按钮
  dismissModal() {
  const that=this;
  that.modalController.dismiss({
    
  });
  that.EventReturnsaluse()
}
// 取消弹窗
hideModal(){
  const that=this;
  that.modalController.dismiss({
    
  });
}
/**
   * 
   * @param 无码退货
   */
  EventReturnsaluse(){
    let that= this;
    that.codelessModal();
  }
   // 无码产品选择
       async codelessModal() {
        let that = this;
        const modal = await that.modalController.create({
          component: CodelessReturnslistPage,
          componentProps: {
            "type": 1,
          }
        });
        await modal.present();
        const { data } = await modal.onWillDismiss(); 
        
        console.log(data,"onWillDismiss");
    } 
}



  
